<template>
    <div class="content-page">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="d-flex flex-wrap align-items-center justify-content-between mb-4">
                        <div>
                            <h4 class="mb-3">Rapports d'Enregistrement</h4>
                        </div>
                        <!-- <a href="/create-entreprise"  class="btn btn-primary add-list" ><i class="las la-plus mr-3"></i>Ajouter une entreprise</a> -->
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="table-responsive rounded mb-3">
                        <table id="example" class="data-table table mb-0 tbl-server-info">
                            <thead class="bg-white text-uppercase">
                                <tr class="ligth ligth-data">
                                    <th>Date</th>
                                    <th>Nombre</th>
                                    <th>Succes</th>
                                    <th>Erreur</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody class="ligth-body">
                                <tr v-for="(type,index) in types" :key="index">
                                    <td>{{ moment(type.created_at).format('DD  MMMM  YYYY H:mm')}}</td>
                                    <td>{{type.nombre}} </td> 
                                    <td>{{type.success}} </td> 
                                    <td>{{type.error}} </td> 
                                    <td >
                                        <div class="d-flex align-items-center list-action">
                                            
                                            <router-link :to="'/show-report/'+type.id"
                                                        class="badge badge-info mr-2" data-toggle="tooltip" data-placement="top" 
                                                        title="" data-original-title="View"><i class="fa fa-eye mr-0"></i>
                                            </router-link>
                                             <a :href="'https://enrolements-backend.yelemoney.com/api/users-export/'+type.id"><button class="btn btn-success"> <i class="fa fa-file-excel-o mr-0"></i></button></a>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="vld-parent">
            <loading :active.sync="isLoading" 
            :can-cancel="true" 
            :is-full-page="fullPage"></loading>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import {URL_API} from '@/config'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import Swal from 'sweetalert2'
import $ from "jquery"
import moment from 'moment'
moment.locale('fr')
export default {
    components: {
            Loading
    },
    data() {
        return {
            permissions: [],
            isLoading: false,
            fullPage: true,
            types: [],
            moment:moment
        };
    },
    mounted(){
        this.getTypes()
    },
    methods:{
        getTypes(){
            let app = this
            app.isLoading = true
            axios.get(URL_API+'auth/report')
            .then(function (reponse){
                console.log('reponse', reponse)
                if (reponse.data.status) {
                    $(document).ready( function () {
                            $('#example').DataTable(
                                {
                                    "lengthMenu": [ 5,10, 25, 50, 75, 100 ],
                                    "pageLength": 10,
                                    'order':[]
                                }
                            );
                        } );
                    app.types = reponse.data.data
                    app.isLoading = false
                }
                
            })
            .catch(function (error){
                console.log('error', error);
            })
        },
        destroy(id) {
            Swal.fire({
                title: 'Do you want to delete this Meal type ?',
                text: "This action is irreversible!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, deleted!'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.isLoading =  true
                    axios.delete(URL_API+'entreprises/'+id)
                    .then(response => {
                        console.log(response)
                        if (response.data.status == true) {
                            this.isLoading =  false
                        Swal.fire(
                            'Deleted!',
                            'The Meal type  was deleted.',
                            'success'
                        )
                        
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        this.errored = true
                        this.isLoading =  false
                    })
                    
                }
            })
            
        },
    }
}
</script>